module.exports = __webpack_public_path__ + "img/DK16339016.3b0cad06.png";